module.exports = __webpack_public_path__ + "static/media/Organization_5.888f669f.svg";